import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, Subscription } from "rxjs/Rx";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { FileUploadService } from "../../../shared/services/fileuploadservice";
import { LoaderService } from "../../../shared/services/loader.service";
import { PapaParseService } from "ngx-papaparse";
import { CountryService } from "../../../shared/location/country.service";
import { StateService } from "../../../shared/location/state.service";
import { CityService } from "../../../shared/location/city.service";
import { AuthService } from "../../../shared/services/auth.service";
import { BackendService } from "../../../shared/services/backend.service";
import { AccountService } from "./../../../shared/account/account.service";
import * as firebase from "firebase/app";
import * as _ from "lodash";
@Component({
  selector: "app-city",
  templateUrl: "./city.component.html"
})
export class CityComponent implements OnInit, OnDestroy {
  private _alert: Subject<string> = new Subject<string>();
  private alertSubscription: Subscription = new Subscription();
  modalReference: NgbModalRef;
  newCities = [{ name: "", error: false }];
  city: any;
  confirmationMessage = "";
  confirmationTitle = "";
  successMessage = "";
  errorMessage = "";
  nameNotUniqueError = "";
  name: string;
  query = "";
  actionType = "";
  fileName;
  fileSize;
  canUpload = false;
  file;
  fileUploadErrorMessage;
  sampleFileUrl = "https://bit.ly/2S21aua";
  defaultCountryCode = "NG";
  defaultCountry;
  countryCode: string;
  countries = [];
  stateId: string;
  cities = [];
  states = [];
  stateOptions = [];
  selectedStateId: string;
  countryOptions = [];
  selectedCountryCode: string;
  selectedFilterStateId: string;
  selectedState: any;
  cityIds = [];
  userId: string;
  user: any;
  authState: firebase.User | null;
  routeSubscription: Subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private csvParseService: PapaParseService,
    private loaderService: LoaderService,
    private modalService: NgbModal,
    private uploadService: FileUploadService,
    private countryService: CountryService,
    private stateService: StateService,
    private router: Router,
    private route: ActivatedRoute,
    private cityService: CityService
  ) {
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.accountService.getProfile(this.userId).subscribe((profile: any) => {
      this.user = profile;
    });

    this.cityService.initNgLgas();

    this.routeSubscription = this.route.params.subscribe(params => {
      const countryCode = params.country || this.countryCode || this.defaultCountryCode;
      this.setDefaultCountry(countryCode);
      this.onCountryFilterChange(countryCode);
      this.onStateFilterChange(params.state);
    });

    this.countryService.getCountries().subscribe(countries => {
      if (countries) {
        this.countries = [];
        countries.forEach(country => {
          this.countries.push({ code: country.iso_3166_1_alpha2, name: country.name.common });
        });
      }
    });

    this.countryOptions = _.values(this.countryService.getFormattedCountries());

    this.cityService.getIdsOfCitiesInUse().subscribe(cityIds => {
      this.cityIds = cityIds;
    });
  }

  ngOnDestroy(): void {
    this.closeModal();
  }

  onCountryFilterChange(countryCode: string): void {
    this.countryCode = countryCode ? countryCode : "NG";
    this.states = [];
    this.cities = [];
    this.setDefaultCountry(this.countryCode);
    this.stateService.getCountryStates(this.countryCode).subscribe(states => {
      if (states) {
        const keys = Object.keys(states);
        keys.forEach(key => {
          this.states.push({ id: key, name: states[key] });
        });
      }
    });
    this.onStateFilterChange("");
  }

  onStateFilterChange(stateId: string): void {
    this.cities = [];
    this.selectedFilterStateId = stateId;
    this.cityService.getStateCities(this.countryCode, stateId).subscribe(countrySnap => {
      if (countrySnap) {
        if (stateId) {
          const stateSnap = countrySnap;
          const stateKeys = Object.keys(stateSnap);
          this.cities = [];
          stateKeys.forEach(key => {
            this.cities.push({ id: key, name: stateSnap[key] });
          });
          this.setSelectedState(stateId);
        } else {
          const stateKeys = Object.keys(countrySnap);
          this.cities = [];
          stateKeys.forEach(stateKey => {
            const cititiesSnap = countrySnap[stateKey];
            const cityKeys = Object.keys(cititiesSnap);
            cityKeys.forEach(key => {
              this.cities.push({ id: key, name: cititiesSnap[key] });
            });
          });
        }
      }
    });
  }

  onSelectedCountryChange(selectedCountryCode: string): void {
    this.selectedCountryCode = selectedCountryCode;
    this.stateService.getCountryStates(this.selectedCountryCode).subscribe(states => {
      this.stateOptions = [];
      if (states) {
        const keys = Object.keys(states);
        keys.forEach(key => {
          this.stateOptions.push({ id: key, name: states[key] });
        });
      }
    });
  }

  onSelectedStateChange(selectedStateId: string): void {
    this.selectedStateId = selectedStateId;
  }

  openBulkUploadModal(modal): void {
    if (this.countryCode && this.selectedFilterStateId) {
      this.openModal(modal, "md");
    } else {
      alert("Please select country and state whose city you want to upload.");
    }
  }

  openFileUploader(): void {
    const element = document.getElementById("bulkUploader") as HTMLElement;
    element.click();
  }

  clearFileUpload(): void {
    this.fileName = "";
    this.fileSize = "";
    this.file = "";
    this.canUpload = false;
  }

  getFileUpload(event): void {
    const result = this.uploadService.verifyFileIsCSV(event);
    if (result.file) {
      this.fileName = result.file.name;
      this.fileSize = `${result.file.size}B`;
      this.file = result.file;
      this.canUpload = true;
    } else {
      this.fileUploadErrorMessage = result.message;
    }
  }

  upload(): void {
    this.loaderService.startLoader();
    this.csvParseService.parse(this.file, {
      complete: results => {
        this.cityService.import(results.data);
        this.clearFileUpload();
        this.loaderService.stopLoader();
        this.showAlert(true, "Cities uploaded successfully.");
      },
      error: () => {
        this.loaderService.stopLoader();
        this.showAlert(false, "Cities could not be uploaded. Please try again");
      }
    });
    this.closeModal();
  }

  createOrEditCity(modal, city): void {
    if (city) {
      this.city = city;
      this.name = city.name;
    } else {
      this.city = undefined;
      this.name = "";
    }

    this.openModal(modal, "md");
  }

  addNewCity(): void {
    if (!this.newCities.length) {
      this.newCities.push({
        name: this.name,
        error: false
      });
    } else {
      for (let i = 0; i < this.newCities.length; i++) {
        if (this.newCities[i]["error"]) {
          alert("Please enter a unique City name ...");

          return;
        }
        if (i === this.newCities.length - 1) {
          this.newCities.push({
            name: this.name,
            error: false
          });

          return;
        }
      }
    }
  }

  checkName(event, index): void {
    const cities = [...this.cities, ...this.newCities];
    this.newCities[index]["error"] = false;

    return;
  }

  removeNewCity(index): void {
    this.newCities.splice(index, 1);
  }

  confirmDelete(city: any, modal): void {
    const message = `Are you sure you want to delete ${city.name} ?`;
    this.confirm("Delete City!", message, modal);
  }

  deleteCity(): void {
    if (!this.selectedFilterStateId && this.city) {
      alert("Please select a valid state by using state filter.");

      return;
    }

    const status = this.cityService.delete(this.countryCode, this.selectedFilterStateId, this.city);
    const msg = status ? "City deleted successfully." : "Oops! Couldn\'t delete city, try again later.";
    this.showAlert(status, msg);
    this.closeModal();
  }

  confirmAction(type, city: any, modal): void {
    this.city = city;
    this.actionType = type;
    const message = `Are you sure you want to ${type} ${city.name} ?`;
    this.confirm("Attention!", message, modal);
  }

  finishAction(): void {
    this.city = null;
  }

  saveCity(): void {
    if (!this.countryCode) {
      alert("Please select a valid country !");

      return;
    }

    if (!this.selectedStateId && !this.city) {
      alert("Please select a valid state !");

      return;
    }

    if (!this.selectedFilterStateId && this.city) {
      alert("Please select a valid state by using state filter.");

      return;
    }

    const data = {
      selectedCountryCode: this.selectedCountryCode,
      selectedStateId: this.selectedStateId
    };

    if (this.city) {
      this.city["name"] = this.name;
    } else {
      data["newCities"] = this.newCities;
    }
    const status = this.cityService.save(data, this.city);
    const message = status ? `City successfully added` : `Oops!! Could not add city, please try again later`;
    this.selectedCountryCode = "";
    this.selectedStateId = "";
    this.newCities = [];

    this.showAlert(status, message);
    this.closeModal();
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.openModal(modal, "sm");
  }

  openModal(modal, modalSize): void {
    this.modalReference = this.modalService.open(modal, { size: modalSize });
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  showAlert(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(message =>
      msgType ? (this.successMessage = message) : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(() => (msgType ? (this.successMessage = undefined) : (this.errorMessage = undefined)));
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  setDefaultCountry(defaultCountryCode: string): void {
    this.defaultCountry = this.countryService.getCountryObjByCode(defaultCountryCode);
  }

  setSelectedState(stateId: string): void {
    if (!stateId) {
      return;
    }

    this.stateService.getStateById(this.countryCode, stateId).subscribe(state => (this.selectedState = state));
  }
}



// WEBPACK FOOTER //
// ./src/app/basic/location/city/city.component.ts